import { useEffect, useState } from "react";
import { gtApi } from "../../api/generalTradeApi";
import { useFormat } from "../../../context/FormatContext";
import "../../styles/generalTrade.css";

const first = () => {
  const d = new Date();
  d.setDate(1);
  return d.toISOString().slice(0, 10);
};

const today = () => new Date().toISOString().slice(0, 10);

export default function CustomerStatement() {
  const { formatDateOnly, formatNumber } = useFormat();

  const [customers, setCustomers] = useState<any[]>([]),
    [filter, setFilter] = useState<any>({
      customer_id: "",
      date_from: first(),
      date_to: today(),
    }),
    [report, setReport] = useState<any>(null);
  useEffect(() => {
    gtApi.customers().then(setCustomers);
  }, []);

  const apply = async () => setReport(await gtApi.statement(filter));

  const print = () => window.print();

  return (
    <div className="gt-card">
      <div className="gt-statement-filter">
        <select
          value={filter.customer_id}
          onChange={(e) =>
            setFilter({ ...filter, customer_id: e.target.value })
          }
        >
          <option value="">Select Customer</option>
          {customers.map((c) => (
            <option key={c.id} value={c.id}>
              {c.company_name}
            </option>
          ))}
        </select>
        <input
          type="date"
          value={filter.date_from}
          onChange={(e) => setFilter({ ...filter, date_from: e.target.value })}
        />
        <input
          type="date"
          value={filter.date_to}
          onChange={(e) => setFilter({ ...filter, date_to: e.target.value })}
        />
        <button className="btn-primary" onClick={apply}>
          Apply
        </button>
        <button className="btn-secondary" onClick={print}>
          Print / PDF
        </button>
      </div>
      {report && (
        <>
          <h2>STATEMENT OF ACCOUNT</h2>
          <p>
            <strong>{report.customer.company_name}</strong>
            <br />
            {report.customer.address}
          </p>
          <p>
            Period: {report.date_from} to {report.date_to}
          </p>
          <table className="gt-allocation-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Document Type</th>
                <th>Document No.</th>
                <th>Description</th>
                <th>Debit</th>
                <th>Credit</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={6}>
                  <strong>Opening Balance</strong>
                </td>
                <td>{Number(report.opening_balance).toFixed(2)}</td>
              </tr>
              {report.transactions.map((r: any, i: number) => (
                <tr key={i}>
                  <td>{formatDateOnly(r.transaction_date)}</td>
                  <td>{r.document_type}</td>
                  <td>{r.document_number}</td>
                  <td>{r.description}</td>
                  <td>{formatNumber(r.debit)}</td>
                  <td>{formatNumber(r.credit)}</td>
                  <td>{formatNumber(r.balance)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <h3 className="gt-closing">
            Closing Balance: RM {Number(report.closing_balance).toFixed(2)}
          </h3>
        </>
      )}
    </div>
  );
}
